import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PageMeta from '@/components/base/PageMeta';
import { useScrollAnimation, getStaggerProps, animationClasses } from '@/hooks/useScrollAnimation';

const channels = [
  {
    name: '博客來',
    description: '財經錢線在博客來的完整品牌書目，提供紙本書籍瀏覽與購買服務。',
    icon: 'ri-book-2-line',
    url: 'https://www.books.com.tw/web/sys_puballb/books/?pubid=sonbookservice',
  },
  {
    name: '誠品',
    description: '誠品線上書店財經錢線品牌書目，支援線上查詢與購買。',
    icon: 'ri-building-line',
    url: 'https://www.eslite.com/search?keyword=%E8%B2%A1%E7%B6%93%E9%8C%A2%E7%B7%9A%E6%96%87%E5%8C%96%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8&manufacturer=WyLosqHntpPpjKLnt5rmlofljJbmnInpmZDlhazlj7giXQ&final_price',
  },
  {
    name: '金石堂',
    description: '金石堂網路書店財經錢線出版品專區，查詢品牌出版書籍。',
    icon: 'ri-book-3-line',
    url: 'https://www.kingstone.com.tw/bookpublish/publist/61855/',
  },
  {
    name: '三民',
    description: '三民網路書店財經錢線出版品搜尋，提供紙本書籍訂購。',
    icon: 'ri-book-open-line',
    url: 'https://www.sanmin.com.tw/search?pu=%E8%B2%A1%E7%B6%93%E9%8C%A2%E7%B7%9A%E6%96%87%E5%8C%96%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8',
  },
  {
    name: 'momo',
    description: 'momo 購物網財經錢線品牌書籍專區，提供線上選購。',
    icon: 'ri-shopping-bag-line',
    url: 'https://www.momoshop.com.tw/search/%E8%B2%A1%E7%B6%93%E9%8C%A2%E7%B7%9A%E6%96%87%E5%8C%96?brand=%E8%B2%A1%E7%B6%93%E9%8C%A2%E7%B7%9A%E6%96%87%E5%8C%96',
  },
  {
    name: '蝦皮',
    description: '蝦皮商城崧博出版官方賣場，提供財經錢線相關書籍選購。',
    icon: 'ri-store-2-line',
    url: 'https://shopee.tw/sonbook',
  },
  {
    name: 'Amazon Kindle',
    description: 'Amazon Kindle 電子書平台財經錢線品牌書目，支援數位閱讀。',
    icon: 'ri-device-line',
    url: 'https://www.amazon.com/s?k=%E8%B2%A1%E7%B6%93%E9%8C%A2%E7%B7%9A%E6%96%87%E5%8C%96%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8',
  },
  {
    name: 'TAAZE 讀冊',
    description: 'TAAZE 讀冊生活財經錢線品牌書目，提供新書與二手書查詢。',
    icon: 'ri-book-read-line',
    url: 'https://www.taaze.tw/rwd_searchResult.html?keyType%5B%5D=3&keyword%5B%5D=%E8%B2%A1%E7%B6%93%E9%8C%A2%E7%B7%9A%E6%96%87%E5%8C%96%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8',
  },
  {
    name: '樂天 Kobo',
    description: '樂天 Kobo 電子書平台，搜尋財經錢線相關電子書出版品。',
    icon: 'ri-tablet-line',
    url: 'https://www.kobo.com/tw/zh',
  },
  {
    name: 'Pubu',
    description: 'Pubu 電子書城財經錢線品牌商店，提供數位出版品瀏覽與購買。',
    icon: 'ri-smartphone-line',
    url: 'https://www.pubu.com.tw/store/4193937',
  },
  {
    name: 'OverDrive',
    description: 'OverDrive 國際數位圖書館平台，提供財經錢線出版品館藏查詢。',
    icon: 'ri-global-line',
    url: 'https://www.overdrive.com/publishers/%E8%B2%A1%E7%B6%93%E9%8C%A2%E7%B7%9A',
  },
  {
    name: 'MyBook',
    description: 'MyBook 電子書平台，搜尋財經錢線相關數位出版內容。',
    icon: 'ri-book-line',
    url: 'https://mybook.mobi/mybook/zh-TW/#',
  },
  {
    name: 'Hami Book',
    description: 'Hami Book 電子書城，搜尋財經錢線出版品與數位閱讀內容。',
    icon: 'ri-store-line',
    url: 'https://www.hamibook.com.tw/Search/finish?keyword=%E8%B2%A1%E7%B6%93%E9%8C%A2%E7%B7%9A',
  },
];

export default function Stores() {
  const heroRef = useScrollAnimation({ threshold: 0.12 });
  const mainRef = useScrollAnimation();

  return (
    <>
      <PageMeta
        title="合作購書通路｜財經錢線"
        description="查看財經錢線合作購書通路完整清單，包括博客來、誠品、金石堂、三民、momo、蝦皮、Amazon Kindle、TAAZE讀冊、樂天Kobo、Pubu、OverDrive、MyBook與Hami Book等平台。"
        canonical="/stores"
      />
      <Navbar />
      <main>
        {/* ── Hero ── */}
        <section ref={heroRef.ref} className="relative min-h-[100svh] flex items-center overflow-hidden">
          <div className="absolute inset-0">
            <video
              src="https://public.readdy.ai/ai/video_res/01a0ec7e-c07f-72f1-b1cd-e26ea603dd0d.mp4"
              autoPlay
              loop
              muted
              playsInline
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-primary-900/55 via-primary-800/35 to-primary-900/65"></div>
          </div>
          <div className="relative z-10 w-full px-4 md:px-6 py-24 md:py-32">
            <div className={`max-w-4xl mx-auto text-center ${animationClasses.base} ${heroRef.isVisible ? animationClasses.visible : animationClasses.hidden}`}>
              <span className="inline-block text-sm md:text-base font-semibold text-accent-200 tracking-wider uppercase mb-4" style={{ textShadow: '0 2px 10px rgba(0,0,0,0.5), 0 1px 3px rgba(0,0,0,0.3)' }}>
                購書通路
              </span>
              <h1 className="font-heading text-3xl md:text-5xl font-bold text-background-50 mb-5 tracking-tight" style={{ textShadow: '0 2px 12px rgba(0,0,0,0.5), 0 4px 24px rgba(0,0,0,0.35)' }}>
                財經錢線合作購書通路
              </h1>
              <p className="text-background-50 text-base md:text-lg max-w-2xl mx-auto leading-relaxed" style={{ textShadow: '0 2px 10px rgba(0,0,0,0.55), 0 1px 4px rgba(0,0,0,0.35)' }}>
                財經錢線相關書籍可透過以下合作購書通路查找。各作品在不同平台的上架狀態、版本、價格及庫存可能不同，實際資訊請以各通路頁面為準。
              </p>
            </div>
          </div>
        </section>

        {/* ── Main Content ── */}
        <section ref={mainRef.ref} className="min-h-[100svh] bg-background-100 py-12 md:py-16">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-6xl mx-auto">
              {/* Title */}
              <div className={`text-center mb-10 md:mb-14 ${animationClasses.base} ${mainRef.isVisible ? animationClasses.visible : animationClasses.hidden}`}>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4 tracking-tight">
                  合作通路列表
                </h2>
                <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
                  財經錢線文化有限公司旗下出版品可於以下各大實體與數位通路查詢。各通路上架狀況可能不同，建議多平台查找。
                </p>
              </div>

              {/* Channel cards — each with individual stagger */}
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
                {channels.map((channel, i) => (
                  <div
                    key={channel.name}
                    {...getStaggerProps(mainRef.isVisible, i, 120, 'fadeUp')}
                    className="group p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300/60 transition-all flex flex-col"
                  >
                    <div className="w-10 h-10 flex items-center justify-center mb-3 rounded-lg bg-primary-50 group-hover:bg-primary-100 transition-colors">
                      <i className={`${channel.icon} text-primary-500 text-lg`}></i>
                    </div>
                    <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-1.5">
                      {channel.name}
                    </h3>
                    <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-4 flex-1">
                      {channel.description}
                    </p>
                    <a
                      href={channel.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      前往通路查找
                      <span className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-external-link-line text-xs"></i>
                      </span>
                    </a>
                  </div>
                ))}
              </div>

              {/* 提醒 — delayed entrance */}
              <div
                {...getStaggerProps(mainRef.isVisible, 13, 900, 'fadeIn')}
                className="mt-10 md:mt-14 p-6 rounded-xl bg-background-50 border border-background-200/70 text-left max-w-3xl mx-auto"
              >
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center mt-0.5 rounded-lg bg-primary-50 shrink-0">
                    <i className="ri-information-line text-primary-500 text-sm"></i>
                  </div>
                  <div className="space-y-2 text-xs md:text-sm text-foreground-500 leading-relaxed">
                    <p>
                      各通路的上架狀態、書籍價格、折扣、版本、庫存、配送與到貨資訊可能因平台而異，實際資訊請以各合作購書通路頁面及實際結帳資訊為準。
                    </p>
                    <p>
                      若在特定平台找不到財經錢線相關書籍，建議先至崧博出版書籍資料庫確認正式書名、作者與ISBN，再前往其他合作購書通路查找。
                    </p>
                    <p>
                      <a
                        href="https://catalog.sonbook.net/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-primary-600 hover:text-primary-700 transition-colors"
                      >
                        前往崧博出版書籍資料庫查詢完整書目
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}